// extracted by mini-css-extract-plugin
module.exports = {"btn":"QuickFillButton_btn__3wSx_","active":"QuickFillButton_active__9gBKF"};